import { GondolaSkuSectionsResponse } from "@/shared/api";
import { CameraSkuSectionProjection } from "./types";

export const findCamerasWithSkuSection = (
  skuSectionId: number,
  response: GondolaSkuSectionsResponse
): CameraSkuSectionProjection => {
  const result: CameraSkuSectionProjection = [];

  response.results.forEach((cameraObject) => {
    Object.entries(cameraObject).forEach(([cameraId, skuSection]) => {
      if (skuSection.sku_section_id === skuSectionId) {
        result.push({ cameraId, skuSection });
      }
    });
  });

  return result;
};
